import React from 'react'
import { styled } from '@mui/material/styles'
import { Container, Grid } from '@mui/material'
import Skeleton from '@mui/material/Skeleton'
import { SkeltonListView } from './SkeltonListView'

const PREFIX = 'SkeltonPagination'

const classes = {
  container: `${PREFIX}-container`,
}

const StyledContainer = styled(Container)(({ theme }) => ({
  [`&.${classes.container}`]: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
    minHeight: '70vh',
  },
}))

export const SkeltonPagination = () => (
  <StyledContainer className={classes.container} maxWidth="md">
    <Grid container={true} justifyContent="center">
      <Skeleton height={30} width="14%" variant="rectangular" />
      <SkeltonListView />
    </Grid>
  </StyledContainer>
)
